module.exports = __webpack_public_path__ + "static/media/cross_white.96cf30f1.svg";